import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import EditRegionComp from '../../components/version-4/MasterForms/EditForms/EditRegionComp'

import { useRegion } from '../../hooks/CompanyConfiguration/useRegion'
import { ROUTES } from '../../shared/constants'
function EditRegion() {
  const [Regiondata, setRegiondata] = useState({
    name: '',
    regionCode: '',
    active: '',
  })
  const { getRegion, region, updateRegion } = useRegion()
  const params = useParams()

  React.useEffect(() => {
    getRegion({ regionId: params.regionId })
  }, [params.regionId])

  const handleRegion = () => {
    updateRegion({
      regionId: params.regionId,
      name: Regiondata.name,
      regionCode: Regiondata.regionCode,
      active: Regiondata.active,
    })
  }

  useEffect(() => {
    if (region) {
      setRegiondata({ ...Regiondata, name: region.name, regionCode: region.regionCode, active: region.active })
    }
  }, [region])
  return (
    <Layout heading="Region" heading2="Edit" url1={ROUTES.REGION} none>
      <HeaderTabLayout heading="Edit Region" state={Regiondata} setState={setRegiondata} content={<EditRegionComp state={Regiondata} setState={setRegiondata} />} addContent={handleRegion} redirect={ROUTES.REGION} />
    </Layout>
  )
}

export default EditRegion
